<template>
  <main>
    <section-view class="header" title="身体内脏">
      <div class="name fx">
        <span>
          <b>{{title}}</b>
          <i></i>
        </span>
      </div>
    </section-view>

    <!-- 项目说明 -->
    <text-card
        v-if="explain"
        title="项目说明"
        :content="explain"
    ></text-card>

    <waterfall-card
        v-if="dynamics.length > 0"
        title="动态跟踪模式"
        :list="dynamics"
        labelKey="time"
        :valueKey="stackValueKey"
        stack="diff"
        line="av"
        format
        tips
        @tip="interpret = true"
    ></waterfall-card>

    <!-- 平均值状态图 -->
    <waterfall-card
        v-if="averageStatus.length > 0"
        title="平均值状态图"
        :list="averageStatus"
        labelKey="time"
        colorKey="color"
        :valueKey="avValueKey"
        format
    ></waterfall-card>

    <!-- 影响身体关联项 -->
    <tag-card title="影响身体关联项" :list="relations" @selected="row => $router.push({path: '/details', query: {code: row.system_code, title: row.item_dict_name, color: row.color, ...query}})"></tag-card>

    <!-- 饮食建议 -->
    <text-card
        title="饮食建议"
        :content="diet"
    ></text-card>

    <!-- 运动建议 -->
    <text-card
        title="运动建议"
        :content="motion"
    ></text-card>

    <!-- 起居建议 -->
    <text-card
        title="起居建议"
        :content="daily"
    ></text-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import {getReportLoopItemOrgans} from "../net/api";
  import SectionView from "../components/SectionView";
  import TextCard from "../components/TextCard";
  import TagCard from "../components/TagCard";
  import WaterfallCard from "../components/WaterfallCard";
  import DialogView from "../components/DialogView";

  export default {
    name: "Nutrition",
    components: {DialogView, WaterfallCard, TagCard, TextCard, SectionView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        code: '',
        title: '',

        // 影响身体的关联项
        relations: [],
        // 项目说明
        explain: '',
        // 饮食建议
        diet: '',
        // 运动建议
        motion: '',
        // 起居建议
        daily: '',

        stackValueKey: {
          one: '初值',
          two: '终值',
        },
        avValueKey: {
          av: '均值',
        },
        // 平均值状态图
        averageStatus: [],

        // 动态跟踪模式
        dynamics: [],

        // 报告等级列表
        levels: [],

        // 解读说明弹窗
        interpret: false
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.title = query.title;
      this.code = query.code;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportLoopItemOrgans({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,

          system_code: this.code
        }).then((data) => {
          this.levels = data.colorData;
          this.relations = data.show_shentiguanlian;
          this.explain = data.item_explain;
          this.averageStatus = data.show_pingjunzhi;
          this.diet = data.show_yinshi;
          this.motion = data.show_yundong;
          this.daily = data.show_qiju;
          this.dynamics = data.show_dongtai;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    .name {
      position: relative;
      padding-top: 60px;

      span {
        position: relative;
        padding: 0 10px;
      }

      b {
        position: relative;
        height: 36px;
        font-size: 50px;
        color: #333333;
        line-height: 36px;
        font-weight: 500;
        z-index: 1;
      }

      i {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -14px;
        content: "";
        display: block;
        height: 18px;
        background: #6CA0EC;
        border-radius: 9px;
      }
    }
  }
</style>